import _ from 'lodash'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useTags } from '@futures-platform/hooks'
import { Tag } from '@futures-platform/ui'
import { fetcher } from '../../helpers/fetcher'
import { DataContext } from '../../store/GlobalState'

//TODO: the logic is insanely complex, should be simplified!
export const PhenomenaTagList = ({ gid, language, scenario }) => {
  const cardBodyRef = useRef()
  const cardBodyRef2 = useRef()

  const {
    state: { langForTransState, isTranslated },
    dispatch,
  } = useContext(DataContext)

  const [translations, settranslations] = useState(null)
  const [originalTitle, setoriginalTitle] = useState(
    () => cardBodyRef.current?.innerHTML,
  )

  const { tags: tagList } = useTags(gid)

  let tags = []
  if (!!scenario?.tags && !!scenario?.tags?.length) {
    tags = scenario?.tags
  }
  let fpTags = []
  let groupTags = []

  // eslint-disable-next-line
  !!tags?.length &&
    tags?.map((tagUri, index) => {
      const tagObj =
        _.find(
          !!tagList && !!tagList?.length && tagList[0],
          ({ uri }) => uri === tagUri,
        ) ||
        _.find(
          !!tagList &&
            tagList?.length > 1 &&
            !!tagList[1]?.length &&
            tagList[1],
          ({ uri }) => uri === tagUri,
        )
      if (!tagObj) {
        return null
      }
      const label = _.isString(tagObj.label)
        ? tagObj.label
        : tagObj.label[language]
      const tagUriSplit = tagUri?.split('/')
      const isFPTags = tagUriSplit[1] === 'theme' ? true : false
      if (!!isFPTags) {
        fpTags.push({ tagUri, label, isFPTags })
      } else groupTags.push({ tagUri, label, isFPTags })
    })

  useEffect(() => {
    const fetcherData = async () => {
      const res1 = await fetcher.translation(
        'en',
        langForTransState,
        originalTitle,
      )
      settranslations(() => {
        return {
          res1,
        }
      })
    }
    !!isTranslated && !!originalTitle && fetcherData()
  }, [isTranslated, originalTitle, langForTransState])

  useEffect(() => {
    if (!!groupTags?.length || !!fpTags?.length) {
      if (true) {
        if (!!cardBodyRef.current?.innerHTML && !cardBodyRef2.current) {
          cardBodyRef2.current = cardBodyRef.current?.innerHTML
        }
        !!cardBodyRef2.current &&
          !originalTitle &&
          setoriginalTitle(() => cardBodyRef2.current)

        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD2,
        //   payload:  true
        // })
      }
    }
  }, [isTranslated, groupTags, fpTags, dispatch, originalTitle])
  if (!tagList || !tagList?.length) {
    return null
  }
  return (
    <>
      {!isTranslated ? (
        <div
          ref={cardBodyRef}
          className="d-flex flex-row flex-wrap"
          style={{
            height: 'auto',
            // minHeight: !!isEditingMode ? '300px' : 'unset',
            height: 'fit-content',
          }}>
          {/* { renderPhenomenaTags && tags?.map((tagUri, index) => {
          const tagObj = _.find(!!tagList && !!tagList?.length && tagList[0], ({ uri }) => uri === tagUri) || _.find((!!tagList && tagList?.length > 1 && !!tagList[1]?.length) ? tagList[1] : (!!tagList2 && tagList2?.length > 1 && tagList2[1]), ({uri }) => uri === tagUri)
          if (!tagObj) {
            return null
          }
          const label = _.isString(tagObj.label) ? tagObj.label : tagObj.label[lang]
          const tagUriSplit = tagUri?.split("/")
          const isFPTags= tagUriSplit[1] === "theme" ? true : false
          return (
            <Tag key={index} active onClick={null} label={label} small isFPTags={isFPTags} isNotFilter={true} />
          )
        })} */}
          {groupTags?.length > 0 &&
            groupTags
              ?.sort(function (a, b) {
                const textA = a.label.toUpperCase()
                const textB = b.label.toUpperCase()
                return textA < textB ? -1 : textA > textB ? 1 : 0
              })
              ?.map((tag, index) => {
                return (
                  <Tag
                    key={index}
                    active
                    onClick={null}
                    label={tag?.label}
                    small
                    isFPTags={tag?.isFPTags}
                    isNotFilter={true}
                  />
                )
              })}
          {fpTags?.length > 0 &&
            fpTags
              ?.sort(function (a, b) {
                const textA = a.label.toUpperCase()
                const textB = b.label.toUpperCase()
                return textA < textB ? -1 : textA > textB ? 1 : 0
              })
              ?.map((tag, index) => {
                return (
                  <Tag
                    key={index}
                    active
                    onClick={null}
                    label={tag?.label}
                    small
                    isFPTags={tag?.isFPTags}
                    isNotFilter={true}
                  />
                )
              })}
        </div>
      ) : (
        <div
          ref={cardBodyRef}
          className="d-flex flex-row flex-wrap"
          style={{
            height: 'auto',
            // minHeight: !!isEditingMode ? '300px' : 'unset',
            height: 'fit-content',
          }}
          dangerouslySetInnerHTML={{
            __html: translations?.res1?.data,
          }}></div>
      )}
    </>
  )
}
